export const ExperimentNames = {
    UseWarmupState: 'specs.events.ui.UseWarmupState',
    EditTicketPDF: 'specs.events.ui.EditTicketPDF',
    PageInstallFlow: 'specs.events.ui.PageInstallFlow',
    PublishedListTips: 'specs.events.PublishedListTips',
    NewBannerLayout: 'specs.events.BMBannerLayout',
    PreloadSeatingSummary: 'specs.events.ui.PreloadSeatingSummary',
    PricingPlansEventsFlexiForm: 'specs.events.ui.PricingPlansEventsFlexiForm',
    NotificationV2: 'specs.events.ui.NotificationV2',
    WixStudioDemoEvents: 'specs.events.ui.WixStudioDemoEvents',
    EventDetailsSlots: 'specs.events.ui.EventDetailsSlots',
    TicketPickerRedesign: 'specs.events.ui.TicketPickerRedesign',
    MessagesNewDesign: 'specs.events.ui.MessagesNewDesign',
    RsvpDynamicMessages: 'specs.events.ui.RsvpDynamicMessages',
    RicosBusinessManager: 'specs.events.ui.Ricos',
    DetailsNoRegistration: 'specs.events.ui.DetailsNoRegistration',
    PapyrusThankYouPageFlow: 'specs.events.ui.PapyrusThankYouPageFlow',
    CheckoutTimeLimit: 'specs.events.ui.EditableCheckoutTimeLimit',
    FixMemberRestrictionNav: 'specs.events.ui.fixMemberRestrictionNav',
    StaffPage: 'specs.events.ui.Staff',
    ZeroPricingOption: 'specs.events.ui.ZeroPricingOption',
    ZeroInsteadOfFree: 'specs.events.ui.ZeroInsteadOfFree',
    TempFixRecurringEvents: 'specs.events.TempFixRecurringEvents',
    SeatingsUiProperties: 'specs.seatings.ui.UiPropertiesMigrationViewer',
};
//# sourceMappingURL=experiments.js.map